import { render } from "./PushNotificationListItem.vue?vue&type=template&id=bf7e4d86"
import script from "./PushNotificationListItem.vue?vue&type=script&lang=js"
export * from "./PushNotificationListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__